<template>
  <div class="container">
    <div class="row vertical-center">
      <div class="col-12">
        <div class="col-12">
          <h1>{{ $t("start.caption") }}</h1>
          <p v-html="$t('start.p1')"></p>
          <p v-html="$t('start.p2')"></p>
          <p v-html="$t('start.p3')"></p>
          <p v-html="$t('start.p4')"></p>
          <p v-html="$t('start.p5')"></p>
        </div>
        <br />
        <br />
        <div class="col-12 right">
          <button class="btn btn-primary" @click="next"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Start",
  methods: {
    next() {
      this.$router.push("/init")
    },
  },
}
</script>
<style scoped>
h1 {
  background-color: #e5efef;
  padding: 10px;
  color: #006265;
  text-align: center;
}
.btn {
  border-radius: 50% !important;
  height: 100px !important;
  width: 100px !important;
  font-size: 0px !important;
}

.btn-primary {
  border-color: white !important;
  background-color: white !important;
  max-width: 100px;
  max-height: 100px;
  background-image: url("../assets/web_button.png");
  background-repeat: no-repeat;
  background-size: cover;
}
@media screen and (max-width: 770px) and (orientation: landscape) {
  .btn-primary {
    border-color: white !important;
    background-color: white !important;
    max-width: 65px;
    max-height: 65px;
    background-image: url("../assets/web_button.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn {
    height: 65px !important;
    width: 65px !important;
    font-size: 0px !important;
  }
}
@media screen and (max-width: 770px) and (orientation: portrait) {
  .btn-primary {
    border-color: white !important;
    background-color: white !important;
    max-width: 65px;
    max-height: 65px;
    background-image: url("../assets/web_button.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn {
    height: 65px !important;
    width: 65px !important;
    font-size: 0px !important;
  }
}
</style>